<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Movimentações de Entrada - Nota Fiscal
      </p>
    </div>

    <div class="q-mt-md text-brand-5 text-weight-bold">
      <div class="row q-gutter-sm q-mb-md">
        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="q-ml-sm texto-titulo-input">Selecione a unidade:</div>
          <lista-unidades-select
            class="input-new-design"
            v-model="unidade.nome"
            :todos="temPermissaoTodasUnidades"
          />
        </div>

        <div class="col-md-2 col-sm-6 col-xs-12">
          <div class="q-ml-sm texto-titulo-input">Data Inicial:</div>
          <q-input
            dense
            outlined
            class="input-new-design"
            v-model="filtros.dataInicial"
            mask="##/##/####"
            placeholder="DD/MM/AAAA"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataInicial"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>

        <div class="col-md-2 col-sm-6 col-xs-12">
          <div class="q-ml-sm texto-titulo-input">Data Final:</div>
          <q-input
            dense
            outlined
            class="input-new-design"
            v-model="filtros.dataFinal"
            mask="##/##/####"
            placeholder="DD/MM/AAAA"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataFinal"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="q-ml-sm texto-titulo-input">Produto:</div>
          <q-input
            dense
            outlined
            class="input-new-design"
            v-model="filtros.produto"
            placeholder="Código ou descrição"
          />
        </div>
      </div>

      <div class="row q-gutter-sm items-end">
        <div class="col-md-2 col-sm-6 col-xs-12">
          <div class="q-ml-sm texto-titulo-input">Cod. Forn.:</div>
          <q-input
            dense
            outlined
            class="input-new-design"
            v-model="filtros.codigoFornecedor"
            placeholder="Código ou descrição"
          />
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12">
          <div class="q-ml-sm texto-titulo-input">Fornecedor:</div>
          <q-input
            dense
            outlined
            class="input-new-design"
            v-model="filtros.fornecedor"
            placeholder="Digite o nome do fornecedor"
          />
        </div>

        <div class="col-md-2 col-sm-6 col-xs-12">
          <div class="q-ml-sm texto-titulo-input">Num. Nota:</div>
          <q-input
            dense
            outlined
            class="input-new-design"
            v-model="filtros.numeroNota"
            placeholder="Número da Nota Fiscal"
          />
        </div>

        <div class="col-md-3 col-sm-6 col-xs-12">
          <q-btn
            class="full-width"
            label="APLICAR FILTROS"
            icon="filter_alt"
            color="primary"
            style="
              border-radius: 8px;
              color: white;
              height: 38px;
              margin-bottom: 2px;
            "
            no-caps
            @click="aplicarFiltros"
          />
        </div>
      </div>
    </div>

    <div class="q-mt-xl">
      <!-- Modal: usuário sem permissão e sem unidade selecionada -->
      <dialog-info-design
        mensagem="Selecione uma Unidade para continuar"
        sub-mensagem="Por favor, selecione uma Unidade no filtro antes de prosseguir."
        :exibir="modalSelecioneUnidade"
        :esconder-confirme="true"
        :show-cancelar="true"
        @resultado="modalSelecioneUnidade = false"
      />

      <template v-if="temPermissaoTodasUnidades || unidade.nome?.id">
        <q-table
          :columns="columns"
          :rows="movimentos"
          :loading="loading"
          class="tabela-tamanho-fixo"
          color="primary"
          table-header-class="bg-accent text-weight-bold"
          flat
          dense
          :rows-per-page-options="perPageList"
          v-model:pagination="pagination"
          @request="onRequest"
          :grid="$q.screen.lt.sm"
        >
          <template v-slot:top-left>
            <span class="text-h6 text-brand-5 text-weight-bold">
              Movimentos ({{ pagination.rowsNumber }})
            </span>
          </template>

          <template v-slot:top-right>
            <q-btn
              @click="exportar"
              class="q-mr-sm"
              label="EXPORTAR"
              no-caps
              style="
                border-radius: 8px;
                background-color: #21324a;
                color: white;
              "
              icon="file_upload"
            />
          </template>

          <template v-slot:item="props">
            <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
              <div class="row card text-grid-table text-brand-5 q-pa-sm">
                <div class="row col-12 justify-between">
                  <div class="col-8">
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span
                        ><strong>Código:</strong>
                        {{ props.row.codigo_produto }}</span
                      >
                    </div>
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span
                        ><strong>Código Form.:</strong>
                        {{ props.row.codigo_produto_fornecedor }}</span
                      >
                    </div>
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span
                        ><strong>Produto:</strong>
                        {{ props.row.nome_produto }}</span
                      >
                    </div>
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span
                        ><strong>Fornecedor:</strong>
                        {{ props.row.provider_name }}</span
                      >
                    </div>
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span
                        ><strong>Num. NF:</strong>
                        <router-link
                          :to="{
                            name: 'nf-editar',
                            params: { notaId: props.row.nf_id },
                          }"
                          class="link-numero-nf"
                        >
                          {{ props.row.nf_numero }}
                        </router-link>
                      </span>
                    </div>
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span
                        ><strong>Qtd NF:</strong>
                        {{
                          formatarNumero(props.row.quantidade_comercial)
                        }}</span
                      >
                    </div>
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span
                        ><strong>Vlr. Unit. NF:</strong>
                        {{
                          formatarMoeda(props.row.business_unity_value)
                        }}</span
                      >
                    </div>
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span
                        ><strong>Total Entrada:</strong>
                        {{ formatarMoeda(props.row.total_item) }}</span
                      >
                    </div>
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span
                        ><strong>Data:</strong>
                        {{ formatarData(props.row.data_recebimento_nf) }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-slot:body-cell-codigo="props">
            <q-td :props="props">
              {{ props.row.codigo_produto }}
            </q-td>
          </template>

          <template v-slot:body-cell-codigo_form="props">
            <q-td :props="props">
              {{ props.row.codigo_produto_fornecedor }}
            </q-td>
          </template>

          <template v-slot:body-cell-produto="props">
            <q-td :props="props">
              {{ props.row.nome_produto }}
            </q-td>
          </template>

          <template v-slot:body-cell-fornecedor="props">
            <q-td :props="props">
              {{ props.row.provider_name }}
            </q-td>
          </template>

          <template v-slot:body-cell-num_nf="props">
            <q-td :props="props">
              <router-link
                :to="{ name: 'nf-editar', params: { notaId: props.row.nf_id } }"
                class="link-numero-nf"
              >
                {{ props.row.nf_numero }}
              </router-link>
            </q-td>
          </template>

          <template v-slot:body-cell-num_pedido="props">
            <q-td :props="props">
              {{ props.row.num_pedido || "-" }}
            </q-td>
          </template>

          <template v-slot:body-cell-qtd_nf="props">
            <q-td :props="props">
              {{ formatarNumero(props.row.quantidade_comercial) }}
            </q-td>
          </template>

          <template v-slot:body-cell-un_nf="props">
            <q-td :props="props">
              {{ props.row.unidade_comercial }}
            </q-td>
          </template>

          <template v-slot:body-cell-qtd_entrada="props">
            <q-td :props="props">
              {{ formatarNumero(props.row.business_amount) }}
            </q-td>
          </template>

          <template v-slot:body-cell-un_catalogo="props">
            <q-td :props="props">
              {{ props.row.unidade_catalogo }}
            </q-td>
          </template>

          <template v-slot:body-cell-vlr_unit_nf="props">
            <q-td :props="props">
              {{ formatarMoeda(props.row.business_unity_value) }}
            </q-td>
          </template>

          <template v-slot:body-cell-total_entrada="props">
            <q-td :props="props">
              {{ formatarMoeda(props.row.total_item) }}
            </q-td>
          </template>

          <template v-slot:body-cell-data="props">
            <q-td :props="props">
              {{ formatarData(props.row.data_recebimento_nf) }}
            </q-td>
          </template>
        </q-table>

        <div class="row justify-center q-mt-md" v-if="movimentos.length > 0">
          <q-pagination
            v-model="pagination.page"
            :max="Math.ceil(pagination.rowsNumber / pagination.rowsPerPage)"
            :max-pages="6"
            direction-links
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            size="sm"
          />
        </div>
      </template>
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
import { usuarioTemPermissao } from "../../../../helpers/permissaoHelper";

const columns = [
  {
    name: "codigo",
    label: "Código",
    align: "left",
    field: "codigo_produto",
    sortable: true,
  },
  {
    name: "codigo_form",
    label: "Código Form.",
    align: "left",
    field: "codigo_produto_fornecedor",
    sortable: true,
  },
  {
    name: "produto",
    label: "Produto",
    align: "left",
    field: "nome_produto",
    sortable: true,
  },
  {
    name: "fornecedor",
    label: "Fornecedor",
    align: "left",
    field: "provider_name",
    sortable: true,
  },
  {
    name: "num_nf",
    label: "Num NF",
    align: "left",
    field: "nf_numero",
    sortable: true,
  },
  {
    name: "num_pedido",
    label: "Num Pedido",
    align: "left",
    field: "num_pedido",
    sortable: true,
  },
  {
    name: "qtd_nf",
    label: "Qtd NF",
    align: "right",
    field: "quantidade_comercial",
    sortable: true,
  },
  {
    name: "un_nf",
    label: "Un. NF",
    align: "center",
    field: "unidade_comercial",
    sortable: true,
  },
  {
    name: "vlr_unit_nf",
    label: "Vlr. Unit. NF",
    align: "right",
    field: "business_unity_value",
    sortable: true,
  },
  {
    name: "qtd_entrada",
    label: "Qtd Entrada",
    align: "right",
    field: "business_amount",
    sortable: true,
  },
  {
    name: "un_catalogo",
    label: "Un. Catálogo",
    align: "center",
    field: "unidade_catalogo",
    sortable: true,
  },
  {
    name: "total_entrada",
    label: "Total Entrada",
    align: "right",
    field: "total_item",
    sortable: true,
  },
  {
    name: "data",
    label: "Data",
    align: "center",
    field: "data_recebimento_nf",
    sortable: true,
  },
];

export default {
  components: { ListaUnidadesSelect, DialogInfoDesign },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const temPermissaoTodasUnidades = computed(() =>
      usuarioTemPermissao(store, "visualizar_todas_unidades")
    );

    const unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData?.id,
    });

    const filtros = ref({
      dataInicial: "",
      dataFinal: "",
      produto: "",
      codigoFornecedor: "",
      fornecedor: "",
      numeroNota: "",
    });

    const movimentos = ref([]);
    const loading = ref(false);
    const isInternalChange = ref(false);
    const modalSelecioneUnidade = ref(false);

    const pagination = ref({
      sortBy: "data",
      descending: true,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 0,
    });

    const perPageList = [15, 30, 50, 100];

    const myLocale = {
      days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
      daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 1,
    };

    // listar as entradas de NF
    const listarEntradas = async (page = 1, rowsPerPage = 15) => {
      // bloqueia a busca se o user n tem permissão e nao selecionou uma unidade
      if (!temPermissaoTodasUnidades.value && !unidade.value.nome?.id) {
        return;
      }

      try {
        loading.value = true;

        const params = {
          page,
          per_page: rowsPerPage,
        };

        if (unidade.value?.nome?.id) {
          params.vendor_id = unidade.value.nome.id;
        }

        if (filtros.value.dataInicial)
          params.data_inicial = filtros.value.dataInicial;
        if (filtros.value.dataFinal)
          params.data_final = filtros.value.dataFinal;
        if (filtros.value.produto) params.search = filtros.value.produto;
        if (filtros.value.codigoFornecedor)
          params.codigo_produto_fornecedor = filtros.value.codigoFornecedor;
        if (filtros.value.fornecedor)
          params.provider_search = filtros.value.fornecedor;
        if (filtros.value.numeroNota)
          params.numero_nota = filtros.value.numeroNota;

        const response = await store.dispatch(
          "notaFiscal/listarEntradasNf",
          params
        );

        if (response.data && response.data.result) {
          movimentos.value = response.data.result.data || [];
          pagination.value.rowsNumber = response.data.result.total || 0;
          pagination.value.page = response.data.result.current_page || 1;
          pagination.value.rowsPerPage =
            response.data.result.per_page || rowsPerPage;
        } else if (response.data && Array.isArray(response.data.data)) {
          movimentos.value = response.data.data;
          pagination.value.rowsNumber =
            response.data.total || response.data.data.length;
          pagination.value.page = response.data.current_page || page;
          pagination.value.rowsPerPage = response.data.per_page || rowsPerPage;
        } else if (response.data && Array.isArray(response.data)) {
          movimentos.value = response.data;
          pagination.value.rowsNumber = response.data.length;
          pagination.value.page = page;
          pagination.value.rowsPerPage = rowsPerPage;
        } else {
          movimentos.value =
            response.data?.results?.data || response.data?.data || [];
          pagination.value.rowsNumber =
            response.data?.results?.total || response.data?.total || 0;
          pagination.value.page =
            response.data?.results?.current_page ||
            response.data?.current_page ||
            page;
          pagination.value.rowsPerPage =
            response.data?.results?.per_page ||
            response.data?.per_page ||
            rowsPerPage;
        }
      } catch (error) {
        console.error("Erro ao carregar entradas:", error);
        quasar.notify({
          message: "Erro ao carregar os dados das entradas",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        loading.value = false;
      }
    };

    // aplicar filtros
    const aplicarFiltros = () => {
      if (!temPermissaoTodasUnidades.value && !unidade.value.nome?.id) {
        modalSelecioneUnidade.value = true;
        return;
      }
      pagination.value.page = 1;
      listarEntradas(1, pagination.value.rowsPerPage);
    };

    const onRequest = (props) => {
      const { page, rowsPerPage } = props.pagination;
      isInternalChange.value = true;
      pagination.value.page = page;
      pagination.value.rowsPerPage = rowsPerPage;
      listarEntradas(page, rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      (newPage) => {
        if (isInternalChange.value) {
          isInternalChange.value = false;
          return;
        }
        listarEntradas(newPage, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => pagination.value.rowsPerPage,
      (newRowsPerPage) => {
        if (isInternalChange.value) return;
        pagination.value.page = 1;
        listarEntradas(1, newRowsPerPage);
      }
    );

    // exportar dados
    const exportar = async () => {
      if (!unidade.value?.nome?.id) {
        quasar.notify({
          message: "Selecione uma unidade para exportar",
          color: "warning",
          actions: [{ label: "Fechar", color: "white" }],
        });
        return;
      }

      try {
        const params = {
          vendor_id: unidade.value.nome.id,
          download: "excel",
        };

        if (filtros.value.dataInicial)
          params.data_inicial = filtros.value.dataInicial;
        if (filtros.value.dataFinal)
          params.data_final = filtros.value.dataFinal;
        if (filtros.value.produto) params.search = filtros.value.produto;
        if (filtros.value.codigoFornecedor)
          params.codigo_produto_fornecedor = filtros.value.codigoFornecedor;
        if (filtros.value.fornecedor)
          params.provider_search = filtros.value.fornecedor;
        if (filtros.value.numeroNota)
          params.numero_nota = filtros.value.numeroNota;

        console.log("Parâmetros enviados para exportação:", params);

        await store.dispatch("notaFiscal/exportarEntradasNf", params);

        quasar.notify({
          message: "Exportação realizada com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } catch (error) {
        console.error("Erro ao exportar:", error);
        quasar.notify({
          message: "Erro ao exportar os dados",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      }
    };

    // formatacao
    const formatarData = (data) => {
      if (!data) return "";

      try {
        if (data.includes("T")) {
          const [datePart, timePart] = data.split("T");
          const [ano, mes, dia] = datePart.split("-");
          const hora = timePart.split(".")[0];
          return `${dia}/${mes}/${ano} ${hora}`;
        }

        if (data.includes("-") && data.includes(" ")) {
          const [datePart, timePart] = data.split(" ");
          const [ano, mes, dia] = datePart.split("-");
          const hora = timePart.split(".")[0];
          return `${dia}/${mes}/${ano} ${hora}`;
        }

        if (data.includes("/")) {
          return data;
        }

        if (data.includes("-")) {
          const [ano, mes, dia] = data.split("-");
          return `${dia}/${mes}/${ano} 00:00:00`;
        }

        return data;
      } catch (error) {
        console.error("Erro ao formatar data:", error);
        return data;
      }
    };

    const formatarMoeda = (valor) => {
      if (!valor && valor !== 0) return "R$ 0,00";

      let numeroValue = valor;
      if (typeof valor === "string") {
        numeroValue = parseFloat(valor.replace(/\./g, "").replace(",", "."));
      } else {
        numeroValue = parseFloat(valor);
      }

      return numeroValue.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    };

    const formatarNumero = (valor) => {
      if (!valor && valor !== 0) return "0,00";

      let numeroValue = valor;
      if (typeof valor === "string") {
        numeroValue = parseFloat(valor.replace(/\./g, "").replace(",", "."));
      } else {
        numeroValue = parseFloat(valor);
      }

      return numeroValue.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const getUnidade = () => {
      if (localStorage.unidade && localStorage.unidade !== "null") {
        const getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      } else if (!temPermissaoTodasUnidades.value) {
        // Sem permissão e sem unidade no localStorage: limpa para forçar seleção
        unidade.value.nome = null;
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData) {
          unidade.value.nome = store.state.org.unidadeData;
          unidade.value.id = store.state.org.unidadeData.id;
          listarEntradas();
        }
      }
    );

    onMounted(() => {
      getUnidade();
      if (unidade.value?.nome?.id) {
        listarEntradas();
      }
    });

    watch(
      () => unidade.value?.nome?.id,
      (newId) => {
        if (newId) {
          listarEntradas();
        }
      },
      { immediate: true }
    );

    return {
      columns,
      unidade,
      filtros,
      movimentos,
      loading,
      pagination,
      perPageList,
      myLocale,
      listarEntradas,
      aplicarFiltros,
      onRequest,
      exportar,
      formatarData,
      formatarMoeda,
      formatarNumero,
      temPermissaoTodasUnidades,
      modalSelecioneUnidade,
    };
  },
};
</script>

<style scoped>
.texto-titulo-input {
  color: #21324a;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
}

.btn-aplicar-filtros {
  min-width: 100px;
  padding: 12px 24px;
  font-weight: 600;
}

.link-numero-nf {
  color: #1976d2;
  text-decoration: none;
  font-weight: 600;
}

.link-numero-nf:hover {
  text-decoration: underline;
}

.card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
}

.text-grid-table {
  font-size: 13px;
}

.tabela-tamanho-fixo {
  max-height: 70vh;
}

@media (max-width: 600px) {
  .texto-titulo-input {
    font-size: 12px;
  }

  .btn-aplicar-filtros {
    width: 100%;
    min-width: unset;
  }
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
